var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.57845 2.49984C3.57845 2.0396 3.95155 1.6665 4.41178 1.6665H16.0785C16.5387 1.6665 16.9118 2.0396 16.9118 2.49984V17.4998C16.9118 17.9601 16.5387 18.3332 16.0785 18.3332H8.57845V16.6665H15.2451V3.33317H5.24512V7.49984H3.57845V2.49984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15586 7.74392C7.4813 7.41848 8.00894 7.41848 8.33437 7.74392L10.8344 10.2439C11.1598 10.5694 11.1598 11.097 10.8344 11.4224L4.16771 18.0891C4.01143 18.2454 3.79946 18.3332 3.57845 18.3332H1.07845C0.618213 18.3332 0.245117 17.9601 0.245117 17.4998V14.9998C0.245117 14.7788 0.332915 14.5669 0.489195 14.4106L7.15586 7.74392ZM1.91178 15.345V16.6665H3.23327L9.06661 10.8332L7.74512 9.51168L1.91178 15.345Z",
    fill: "white"
  }))));
};
export { SvgEdit as ReactComponent };
export default __webpack_public_path__ + "assets/4e8a24b7.svg";